<div class="download-pdf">
  <div class="left-img">
    <img src="https://flowaccountcdn.com/images/qrcodeline.JPG" width="100%">
  </div>
  <div class="right-content">
    <span>ดาวน์โหลดคู่มือนี้ในรูปแบบไฟล์ pdf</span><br />
    <span>เพียงสมัครใช้งาน โปรแกรมบัญชี ฟรี กับเรา</span>
    <a class="download" href="https://auth.flowaccount.com/{{ translate.currentLang }}/Account/Register"
      target="_blank">โหลดเลย!</a>
  </div>
</div>